/**
 * User: WangMeng
 * Date: 2018-05-21
 * Time: 18:51
 * Desc: 最新动态弹框
 */
import styles from './listModal.scss';
import React, { PureComponent } from 'react';
import { Modal, Table } from 'antd';
import { dateFormat } from '../../../../../utils/formatter';
import OuterUrlLink from '../../../../common/outerUrlLink/OuterUrlLink';
import { noticeDetail } from '../../../../../services/regulatoryStatistical';

export default class OverviewModal extends PureComponent {
    constructor(props) {
        super(props);
        this.trendData = [];
        this.state = {
            loading: true,
            tableData: []
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.visible && nextProps.visible !== this.props.visible) {
            this.setState({
                tableData: []
            }, () => {
                this.getData();
            });
        }
    }

    getData = () => {
        const { item, searchParams } = this.props;
        this.setState({
            loading: true
        });

        noticeDetail({ companyName: item.companyName, ...searchParams }).then(data => {
            data = data || [];
            this.setState({
                loading: false,
                tableData: data
            });
        }).catch(() => {
            this.setState({
                loading: false,
                tableData: []
            });
        });

    };

    getLink = (d) => {
        if (d.pubnishType === 4 || d.pubnishType === 8) {
            return '';
        }
        return d.linkUrl;
    };

    getColumns = () => {
        return [{
            title: '股票代码',
            dataIndex: 'stockCode',
            width: 90
        }, {
            title: '公司简称',
            dataIndex: 'sesName',
            width: 100
        }, {
            title: '公司全称',
            dataIndex: 'companyName'
        }, {
            title: '公告时间',
            dataIndex: 'pubDate',
            width: 100,
            render: dateFormat
        }, {
            title: '发布机构',
            dataIndex: 'pubInstitute',
            width: 160
        }, {
            title: '公告类型',
            dataIndex: 'letterType',
            width: 110
        }, {
            title: '相关链接',
            dataIndex: 'linkUrl',
            width: 90,
            render: (v, d) => <OuterUrlLink url={this.getLink(d)} text="查看"/>
        }];
    };

    render() {
        const { visible, onCancel } = this.props;
        const { loading, tableData } = this.state;

        return (
            <Modal
                wrapClassName={styles.listModal}
                width={1000}
                onCancel={onCancel}
                visible={visible}
                footer={null}
                closable={false}
            >
                <Table
                    rowKey="id"
                    loading={loading}
                    pagination={false}
                    columns={this.getColumns()}
                    dataSource={tableData}
                    bordered
                    footer={null}
                />
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/state/newest/ListModal.jsx